/** @jsx jsx */
import React, { Fragment } from 'react'
import { jsx } from 'theme-ui'
import { Col, Row, EVEntry } from '../helpers/react'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({
  entries = [],
  children,
  colsMobile = 1,
  colsTablet = 2,
  colsDesktop = 3,
  options = {},
}) => {
  const rowStyles = options?.styles?.row || {}
  const colStyles = options?.styles?.col || {}

  const rowSx = { ...rowStyles }
  const colSx = {
    variant: 'modules.collectionGrid.col',
    // '> div': { height: '100%' },
    /**
     * FIXME: The collection should not be responsible for the
     * vertical height of its children This is likely to ensure that
     * columns have the same height but couples `RichTextBlocks` to
     * requiring a wrapping div
     */
    ...colStyles,
  }

  const childrenArray = entries
    ? entries.map((entity, i) => <EVEntry {...entity} key={i} />)
    : children

  return (
    <Fragment>
      <Row cols={[colsMobile, colsTablet, colsDesktop]} direction='row' wrap sx={rowSx}>
        <For index='key' each='child' of={childrenArray}>
          <If condition={child.props}>
            <Col span={1} key={key} sx={colSx}>
              {/* eslint-disable-next-line react/jsx-no-undef */}
              <child.type {...child.props} />
            </Col>
          </If>
        </For>
      </Row>
    </Fragment>
  )
}
